import { inject, Injectable } from '@angular/core';
import { StateContext } from '@ngxs/store';
import { TableStateModel } from '../table.state.model';
import { Pagination } from '@core/models/pagination.model';
import { ConfigService } from '@core/services/config';
import { TableActions } from '../table.actions';

@Injectable({
  providedIn: 'root',
})
export class ConfigurationsHandler {
  constructor() {}
  configService = inject(ConfigService);

  handleConfigurationsLoad(
    ctx: StateContext<TableStateModel>,
    params: Pagination
  ) {
    this.configService.getConfigList().subscribe({
      next: (response) => {
        ctx.dispatch(
          new TableActions.LoadTableDataSuccess({
            tableKey: 'configurations',
            data: response.data?.configs,
            totalCount: response.data?.total_count,
          })
        );
      },
      error: (error) => {
        ctx.dispatch(
          new TableActions.LoadTableDataFailure({
            tableKey: 'configurations',
            error: error.message,
          })
        );
      },
    });
  }
}
